import { Button } from 'common/components/Button/Button'
import { pagesPathsEnum } from 'common/router/router.enum'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import { FC } from 'react'
import styled from 'styled-components'

export const FullTestSuiteCard: FC = () => {
  const { t } = useTranslation('common')

  return (
    <Card>
      <div className="card-content">
        <h2 className="card-title">{t('full_test_suite_title')}</h2>
        <p className="card-description">{t('full_test_suite_description')}</p>
        <div className="card-actions">
          <Link href={pagesPathsEnum.login} passHref legacyBehavior>
            <a>
              <Button variant="primary" size="large" className="cta-button">
                {t('full_test_suite_login')}
              </Button>
            </a>
          </Link>
          <Link href={pagesPathsEnum.candidateRegister} passHref legacyBehavior>
            <a>
              <Button variant="greyShadow" size="large" className="cta-button">
                {t('full_test_suite_sign_up')}
              </Button>
            </a>
          </Link>
        </div>
      </div>
    </Card>
  )
}

const Card = styled.section`
  background: linear-gradient(135deg, #382b73 0%, #4a3a8a 100%);
  border-radius: 16px;
  padding: 2rem;
  margin: 2rem auto;
  max-width: 1200px;
  width: 100%;
  color: white;
  text-align: center;

  .card-content {
    max-width: 800px;
    margin: 0 auto;
  }

  .card-title {
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 1rem;
    line-height: 1.2;
  }

  .card-description {
    font-size: 1.125rem;
    margin-bottom: 2rem;
    opacity: 0.9;
    line-height: 1.5;
  }

  .card-actions {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: center;
    justify-content: center;

    @media screen and (min-width: 576px) {
      flex-direction: row;
      gap: 1.5rem;
    }
  }

  .cta-button {
    font-weight: 500;
    flex-shrink: 0;
    min-width: 160px;

    @media screen and (min-width: 576px) {
      max-width: 240px;
    }
  }

  @media screen and (max-width: 768px) {
    padding: 1.5rem;
    margin: 1rem 0;

    .card-title {
      font-size: 1.5rem;
    }

    .card-description {
      font-size: 1rem;
    }
  }

  @media screen and (max-width: 480px) {
    padding: 1rem;

    .card-title {
      font-size: 1.25rem;
    }

    .card-description {
      font-size: 0.9rem;
    }

    .card-actions {
      width: 100%;
    }

    .cta-button {
      width: 100%;
      max-width: none;
    }
  }
`

export default FullTestSuiteCard
